import {
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  Paper,
} from "@mui/material";
import theme from "../../configs/theme";

function getEstado(quantity, min_stock) {
  if (quantity === 0) return "❌ Sin stock";
  if (quantity < min_stock) return "⚠️ Bajo";
  return "✅ Ok";
}

function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("es-AR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

export default function StockTableUI({ headerData, data }) {
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        maxHeight: "54vh",
        overflowY: "auto",
        "&::-webkit-scrollbar-track": {
          background: theme.tableColors.header,
        },
      }}
    >
      <Table stickyHeader>
        <TableHead
          sx={{
            "& .MuiTableCell-root": {
              backgroundColor: theme.tableColors.header,
              fontSize: {
                md: theme.fontSizes.medium,
                sm: theme.fontSizes.small,
              },
              fontWeight: "bold",
              color: theme.colors.black,
              padding: "12px",
              borderBottom: "1px solid #ffffff",
            },
          }}
        >
          <TableRow>
            {headerData.map((item) => (
              <TableCell key={item}>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody
          sx={{
            backgroundColor: theme.tableColors.body,
            "& .MuiTableCell-root": {
              fontSize: {
                md: theme.fontSizes.medium,
                sm: theme.fontSizes.small,
              },
              color: theme.colors.black,
              padding: "10px",
            },
          }}
        >
          {data.map((row) => (
            <TableRow 
              key={row.id}
              sx={{
                "&:hover": {
                  backgroundColor: theme.tableColors.hover,
                },
              }}
            >
              <TableCell 
                sx={{
                  maxWidth: 160,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {row.product_name}
              </TableCell>
              <TableCell
                sx={{
                  maxWidth: 140,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {row.product_type}
              </TableCell>
              <TableCell>{row.quantity}</TableCell>
              <TableCell>{row.min_stock}</TableCell>
              <TableCell>{`$ ${row.product_price}`}</TableCell>
              <TableCell>
                {formatDate(row.last_update)}
              </TableCell>
              <TableCell>{getEstado(row.quantity, row.min_stock)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}